// jQuery(function($){
//   $('.js-pagemenu__open').on('click', function(){
//     var menu = $(this).attr('data-menu');
//     $(menu).toggleClass('js-menu__expanded');
//      $(menu).parent().toggleClass('js-menu__expanded');
// });

// $('.js-menu__context, .js-menu__close').on('click', function(event){
// if ( $(event.target).hasClass('js-menu__context') || $(event.target).hasClass('js-menu__close') ) {
//  $('.js-menu__expanded').removeClass('js-menu__expanded');
// }
// });
// });


document.addEventListener('DOMContentLoaded', function() {
  var menuButtons = document.querySelectorAll('.js-pagemenu__open');
  menuButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var menuSelector = button.getAttribute('data-menu');
      var menu = document.querySelector(menuSelector);
      menu.classList.toggle('js-menu__expanded');
      menu.parentElement.classList.toggle('js-menu__expanded');
    });
  });

  var closeElements = document.querySelectorAll('.js-menu__context, .js-menu__close');
  closeElements.forEach(function(element) {
    element.addEventListener('click', function(event) {
      if (event.target.classList.contains('js-menu__context') || event.target.classList.contains('js-menu__close')) {
        var expandedMenus = document.querySelectorAll('.js-menu__expanded');
        expandedMenus.forEach(function(menu) {
          menu.classList.remove('js-menu__expanded');
        });
      }
    });
  });
});


// document.addEventListener("DOMContentLoaded", function() {
//    var submitButton = document.querySelector(".f-product-form__submit");
//     if (submitButton) {
//        submitButton.addEventListener("click", function(event) {
           
//             alert("Your custom message goes here!");
//         });
//     }
// });


document.addEventListener('DOMContentLoaded', function () {

   document.querySelectorAll('.custom_reorder').forEach(button => {
    button.addEventListener('click', function () {
      let variantId = this.getAttribute('data-id');
      let quantity =  this.getAttribute('data-itemquantity');
      let inventory = this.getAttribute('data-inventory');
      let colorcode = this.getAttribute('data-colorcode');
      let pantone  =  this.getAttribute('data-pantone');
      let yards  =  this.getAttribute('data-yards');
      // console.log(colorcode);
      // console.log(pantone);
      const payload = {
        id: variantId,
        quantity: parseInt(quantity),
        properties: {
          Color: colorcode,
          Pantone: pantone,
          Yards:yards
        }
      };
       
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(response => {
          if (!response.ok) {
               $(".draft_error").css("display", "block"); 
               return response.json().then(error => {
              throw new Error(error.message ||  $(".draft_error").css("display", "block") );
            });
          }
          return response.json();
        })
        .then(data => {
         location.pathname = '/cart'
          // console.log(data);
        })
        .catch(error => {
          // Error message
         // alert(`Error: ${error.message}`);
        });
    });
  });
});



